import React from 'react'

// react router
import { Link } from 'react-router-dom';

// icons : feather
import FeatherIcon from 'feather-icons-react';

// images
import noImgFound from 'assets/images/no-img-found.png'
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl/useStoreUrl';


export default function ProductsView(props) {
    // props
    const { orderDetails } = props

    // store url
    const [storeUrl] = useStoreUrl()

    return (
        <React.Fragment>
            {/* page border box */}
            <div className="page-border-box mb-3">
                <div className="pbb-inner">
                    <p className="head st-fw-600 st-text-color2 st-fs-16 mb-3">Order items: <span>{orderDetails.cart_items}</span></p>

                    <div className="products-view">
                        {/* product view */}
                        <div className="product-view-table">
                            <div className="table-responsive">
                                <table className="table mb-0">
                                    <thead>
                                        <tr>
                                            <th colSpan={2}>
                                                Product Details
                                            </th>
                                            <th className="text-end">
                                                SKU
                                            </th>
                                            <th className="text-end">
                                                Price
                                            </th>
                                            <th className="text-end">
                                                Qty
                                            </th>
                                            <th className="text-end">
                                                Subtotal
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {
                                            orderDetails?.content?.length && orderDetails.content.map(item => (
                                                <tr key={item.cart_id}>
                                                    <td width={60}>
                                                        <div className="img-sec" style={{ width: 60 }}>
                                                            <img
                                                                src={orderDetails?.images[item.cart_id] || noImgFound}
                                                                alt=""
                                                                className="img-fluid img-fluid-height"
                                                                onLoad={ev => ev.target.parentNode.classList.add("loaded")}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <Link
                                                            to={`${storeUrl}/catalog/products/edit/${item.product_id}`}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            className="prod-heading-in-table st-fs-18 mb-2 st-text-color st-fw-600 text-decoration-none d-inline-block">
                                                            {item.product_name}
                                                        </Link>
                                                        <p className="prod-details-in-table st-text-color2">
                                                            <span className="me-2">
                                                                {item.variant_name}
                                                            </span>
                                                        </p>
                                                    </td>
                                                    <td width={100}>
                                                        <p className="prod-heading-in-table st-fs-18 mb-2 st-text-color st-fw-600 text-end">
                                                            {item.sku}
                                                        </p>
                                                    </td>
                                                    <td width={150}>
                                                        <p className="prod-heading-in-table st-fs-18 mb-2 st-text-color st-fw-600 text-end">
                                                            {item.display_price}
                                                        </p>
                                                    </td>
                                                    <td width={130}>
                                                        <p className="prod-heading-in-table st-fs-18 mb-2 st-text-color st-fw-600 text-end">
                                                            {item.quantity}
                                                        </p>
                                                    </td>
                                                    <td width={130}>
                                                        <p className="prod-heading-in-table st-fs-18 mb-2 st-text-color st-fw-600 text-end">
                                                            {item.total_price}
                                                        </p>
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>

                                    <tfoot>
                                        <tr>
                                            <td colSpan={5} className="border-top">
                                                <p className="prod-heading-in-table st-fs-17 st-text-color text-end">
                                                    Items:
                                                </p>
                                            </td>
                                            <td className="border-top">
                                                <p className="prod-heading-in-table st-fs-17 st-text-color st-fw-600 text-end">
                                                    {orderDetails?.cart_sub_total}
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={5} className="">
                                                <p className="prod-heading-in-table st-fs-17 st-text-color text-end">
                                                    Discount:
                                                </p>
                                            </td>
                                            <td className="">
                                                <div className="d-flex align-items-center justify-content-end">
                                                    {
                                                        orderDetails?.coupon_code ? ( // if some coupon code is applied by the user
                                                            <div className="discount-info position-relative ms-2">
                                                                <p className="text-head text-danger prod-heading-in-table st-fs-17 st-text-color st-fw-600 text-end">
                                                                    {orderDetails?.cart_discount}
                                                                </p>
                                                                <div className="content position-absolute">
                                                                    <div className="inner">
                                                                        <p className="mb-0">
                                                                            {orderDetails?.cart_discount} for applied coupon
                                                                            {/* {
                                                                                orderDetails?.content?.length ? (
                                                                                    <React.Fragment>
                                                                                        {
                                                                                            orderDetails.content[0]?.coupon_code ? (
                                                                                                ""
                                                                                            ) : null
                                                                                        }
                                                                                    </React.Fragment>
                                                                                ) : null
                                                                            } */}
                                                                            <span className="d-block st-fw-600">
                                                                                '{orderDetails?.coupon_code}'
                                                                            </span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <p className="text-danger prod-heading-in-table st-fs-17 st-text-color st-fw-600 text-end">
                                                                {orderDetails?.cart_discount}
                                                            </p>
                                                        )
                                                    }
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={5} className="">
                                                <p className="prod-heading-in-table st-fs-17 st-text-color text-end">
                                                    Shipping:
                                                </p>
                                            </td>
                                            <td className="">
                                                <p className="prod-heading-in-table st-fs-17 st-text-color st-fw-600 text-end">
                                                    {orderDetails?.currency_shipping ?? "$0.00"}
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={5} className="">
                                                <p className="prod-heading-in-table st-fs-17 st-text-color text-end">
                                                    Tax:
                                                </p>
                                            </td>
                                            <td className="">
                                                <p className="prod-heading-in-table st-fs-17 st-text-color st-fw-600 text-end">
                                                    {orderDetails?.currency_tax ?? "$0.00"}
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={5} className="">
                                                <p className="prod-heading-in-table st-fs-19 st-fw-600 st-text-color text-end">
                                                    Total:
                                                </p>
                                            </td>
                                            <td className="">
                                                <p className="prod-heading-in-table st-fs-19 st-text-color st-fw-600 text-end">
                                                    {orderDetails?.cart_total}
                                                </p>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}
